import { useEffect, useRef } from 'react';

export const useFileFilters = ({ selectedBucket, sourceConfig, onSourceConfigChanged }) => {
  // Track the previous value of path_exclusions to detect when it's first turned on
  const prevPathExclusionsRef = useRef(sourceConfig?.path_exclusions);

  useEffect(() => {
    const wasPathExclusionsEnabled = prevPathExclusionsRef.current;
    const isPathExclusionsEnabled = sourceConfig?.path_exclusions;

    // Update the ref for next render
    prevPathExclusionsRef.current = isPathExclusionsEnabled;

    // Only auto-populate when path_exclusions is FIRST turned on (from false/undefined to true)
    if (
      selectedBucket?.path &&
      sourceConfig &&
      !wasPathExclusionsEnabled &&
      isPathExclusionsEnabled
    ) {
      const updatedConfig = {
        ...sourceConfig,
        'whitelist.pathmatchers': selectedBucket.path,
      };
      onSourceConfigChanged(updatedConfig);
    }
  }, [selectedBucket?.path, sourceConfig, onSourceConfigChanged]);
};
